"use client";

import Link from "next/link";
import { useAuthStore } from "@/store/auth";

/**
 * 비로그인 사용자에게만 노출되는 가치 제안 카드.
 * 첫 인상 = "왜 내가 이걸 써야 하지?" 답.
 *
 * 로그인 사용자에게는 이미 친숙하므로 노출 X (노이즈 방지).
 */
export function ValuePropHero() {
  const { isLoggedIn } = useAuthStore();
  if (isLoggedIn) return null;

  return (
    <section className="px-4 mt-4">
      <div className="rounded-2xl bg-gradient-to-br from-primary/15 via-primary/8 to-bg-elevated border border-primary/30 px-4 py-4">
        <p className="text-base font-black text-text leading-snug">
          어떤 메뉴를 새로 도입할까?
          <br />
          <span className="text-primary">데이터로 미리 알려드립니다.</span>
        </p>
        <p className="text-xs text-text-sub mt-2 leading-relaxed">
          공개된 카페 트렌드를 정리·분석해 카페 사장님 관점에서 보여드립니다.
          <br />
          도입 적기·식어가는 메뉴를 한눈에.
        </p>
        <div className="mt-3 flex items-center gap-2">
          <Link
            href="/login"
            className="flex-1 text-center py-2.5 rounded-xl bg-primary text-bg font-bold text-sm hover:bg-primary/90 transition-colors"
          >
            무료로 시작하기 →
          </Link>
          <Link
            href="/guide"
            className="px-3 py-2.5 rounded-xl border border-border text-text-sub hover:text-text hover:border-primary/40 text-xs font-semibold transition-colors"
          >
            사용 가이드
          </Link>
        </div>
      </div>
    </section>
  );
}
